import React from 'react';
import AuditLog from '../../components/AdminNext/AuditLog';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Audit log — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <AuditLog />
      </HeadLessLayout>
    )
  };
}

export default action;
